"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Separator } from "@/components/ui/separator";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const credentials = [{
  title: "40年以上のフロリダ州における法律実務経験",
  description: "1983年以来のフロリダ州での法律実務経験を有し、フロリダ州およびニューヨーク州の弁護士資格を有しています。"
}, {
  title: "複雑な商取引および企業法務の専門知見",
  description: "会社の設立、所有権プランニング、契約交渉、企業の買収・売却など、ビジネスのあらゆる段階において法的助言を行います。"
}, {
  title: "不動産取引および所有権移転の実務",
  description: "南フロリダにおける不動産取引、権利移転、権利書手続きにおける実務的な法的サポートを提供します。"
}, {
  title: "遺産相続・プロべート（遺産検認）手続きの指導",
  description: "遺言書作成、信託、相続財産の整理など、相続および遺産管理手続きに関する法的サポートを行います。"
}, {
  title: "弁護士報酬ヒアリングにおける専門家証人としての役割",
  description: "弁護士報酬に関するヒアリングにおいて、客観的な専門家証人（Expert Witness）として証言業務を行います。"
}, {
  title: "ビジネス訴訟および紛争解決",
  description: "企業の法的リスクと選択肢を検討しながら対応します。"
}];
export default function Timeline() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".tl-header", {
        y: 16,
        opacity: 0
      });
      gsap.to(".tl-header", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.set(".credential-card", {
        y: 20,
        opacity: 0
      });
      gsap.to(".credential-card", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".tl-header", ".credential-card"], {
        opacity: 1,
        x: 0,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="29591" id="professionalexperiencetimeline" data-nav="dark" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div ref={container} className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto tl-header">
          <p className="font-mono uppercase text-[0.75rem] font-medium tracking-[0.2em]" style={{
          color: "var(--secondary)"
        }}>
            経歴・資格
          </p>
          <h2 className="mt-4 font-serif font-bold leading-[1.15]" style={{
          fontSize: "clamp(2rem, 3.5vw, 2.5rem)",
          color: "var(--primary)"
        }}>
            40年以上にわたる法律実務と専門的経験
          </h2>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {credentials.map((item, i) => <div key={i} data-index={i} className="credential-card bg-card p-8 rounded-lg shadow-sm flex flex-col justify-between border border-border">
              <div>
                <h3 className="font-serif text-xl font-semibold text-foreground">
                  {item.title}
                </h3>
                <Separator className="my-6 bg-border" />
                <p className="font-sans text-muted-foreground text-base leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}